// Client V1 imports
const airbrake = require('client/lib/airbrake')
const { send: ajax } = require('client/lib/request')
const { track } = require('client/lib/analytics')
// Common Client v2 imports
const { navigate } = require('client-v2/common/state/router/actions')
const { userProfileHref } = require('client-v2/common/models/user/actions')

// Action types

const COLLECTION_DELETED = 'COLLECTION_DELETED'
const COLLECTION_EDITED = 'COLLECTION_EDITED'
const COLLECTION_FOLLOWING_CHANGE = 'COLLECTION_FOLLOWING_CHANGE'

// Action enums

const COLLECTION_FOLLOWING_CHANGE_PENDING = 'COLLECTION_FOLLOWING_CHANGE_PENDING'

// Action creators

function collectionFollowingChange(collectionId, isFollowing) {
  return {
    type: COLLECTION_FOLLOWING_CHANGE,
    payload: {
      collectionId,
      isFollowing
    }
  }
}

function collectionFollowingChangePending(collectionId) {
  return collectionFollowingChange(
    collectionId,
    COLLECTION_FOLLOWING_CHANGE_PENDING
  )
}

function collectionDeleted(collectionId) {
  return {
    type: COLLECTION_DELETED,
    payload: {
      collectionId
    }
  }
}

function collectionEdited(collection) {
  return {
    type: COLLECTION_EDITED,
    payload: {
      collectionId: collection.id,
      collection
    }
  }
}

// Action dispatchers

function navigateToCollectionProfile(options) {
  return navigateToCollectionProfilePosts(options)
}

function navigateToCollectionProfileSubscribers({ collection, event, pageContext }) {
  return function (dispatch) {
    dispatch(navigate({
      event,
      href: collectionProfileSubscribersHref(collection),
      pageContext
    }))
  }
}

function navigateToCollectionProfilePosts({ collection, event, pageContext }) {
  return function (dispatch) {
    dispatch(navigate({
      event,
      href: collectionProfilePostsHref(collection),
      pageContext
    }))
  }
}

function navigateToCollectionUserProfile({ collection, event, pageContext }) {
  return function (dispatch) {
    dispatch(navigate({
      event,
      href: collectionUserProfileHref(collection),
      pageContext
    }))
  }
}

function showCollectionEditModal({ collection }) {
  // Mitigate circular dependency
  const clientV1Bridge = require('client-v2/common/client-v1-bridge')
  return function () {
    clientV1Bridge.showMixEditModal({ mix: collection })
  }
}

function showCollectionShareModal({ collection }) {
  // Mitigate circular dependency
  const clientV1Bridge = require('client-v2/common/client-v1-bridge')
  return function () {
    clientV1Bridge.showMixShareModal({ mix: collection })
  }
}

function toggleFollowing({ collection, pageContext }) {
  return function (dispatch) {
    const toggledFollowing = !collection.isFollowing
    const action = toggledFollowing ? 'follow' : 'unfollow'
    dispatch(collectionFollowingChangePending(collection.id))
    ajax({
      url: `/api/v0.1/mix/${collection.id}/${action}`,
      method: 'post',
      data: {
        'page_context': pageContext
      }
    })
    .then(() =>
      track(`${action}-mix`, {
        // TODO context (i.e. post-remix | none)
        'mix_id': collection.id,
        slug: collection.slug,
        metabase: {
          'actioned_object_type': 'mix',
          'actioned_object_id': collection.id
        },
        'page_context': pageContext
      })
    )
    .then(() => {
      dispatch(collectionFollowingChange(collection.id, toggledFollowing))
    })
    .catch(err => airbrake.notify(err))
  }
}

// Helpers

function collectionProfileHref(collection) {
  return collectionProfilePostsHref(collection)
}

function collectionProfileSubscribersHref(collection) {
  return `/${collection.username}/${collection.slug}/subscribers`
}

function collectionProfilePostsHref(collection) {
  return `/${collection.username}/${collection.slug}`
}

function collectionUserProfileHref(collection) {
  return userProfileHref(collection)
}

module.exports = {
  // Types
  COLLECTION_DELETED,
  COLLECTION_EDITED,
  COLLECTION_FOLLOWING_CHANGE,
  // Enums
  COLLECTION_FOLLOWING_CHANGE_PENDING,
  // Creators
  collectionDeleted,
  collectionEdited,
  collectionFollowingChange,
  collectionFollowingChangePending,
  // Dispatchers
  navigateToCollectionProfile,
  navigateToCollectionProfileSubscribers,
  navigateToCollectionProfilePosts,
  navigateToCollectionUserProfile,
  showCollectionEditModal,
  showCollectionShareModal,
  toggleFollowing,
  // Helpers
  collectionProfileHref,
  collectionProfileSubscribersHref,
  collectionProfilePostsHref,
  collectionUserProfileHref
}
